export function canConnectPasskeyAccount(user: {
  passkeyLinked: boolean;
  telegramLinked: boolean;
}): boolean {
  return user.telegramLinked && !user.passkeyLinked;
}
